import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMeetWhere = (props) => /* @__PURE__ */ _jsxs("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Features_2",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_0_18",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 56,
			height: 56,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Where icon background",
				width: 56,
				height: 56,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_0_18)",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Subtract",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M34 0C46.1503 0 56 9.84974 56 22C56 31.1922 50.3617 39.0656 42.3555 42.3555C39.0656 50.3617 31.1922 56 22 56C9.84974 56 0 46.1503 0 34C0 24.808 5.63763 16.9335 13.6436 13.6436C16.9335 5.63763 24.808 0 34 0ZM22 12C19.0417 12 16.2201 12.5847 13.6436 13.6436C12.5847 16.2201 12 19.0417 12 22C12 34.1503 21.8497 44 34 44C36.9581 44 39.779 43.4142 42.3555 42.3555C43.4142 39.779 44 36.9581 44 34C44 21.8497 34.1503 12 22 12Z",
				fill: "url(#paint0_linear_0_18)"
			}), /* @__PURE__ */ _jsx("g", {
				id: "Vector",
				filter: "url(#filter0_d_0_18)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M32.8309 30.3741C33.9841 29.0533 35 27.4505 35 25.8557C34.9999 23.7526 33.4362 22 31.2558 22C30.2193 22 29.2152 22.3325 28 23.4366C26.7848 22.3325 25.7807 22 24.7442 22C22.5638 22 21 23.7526 21 25.8557C21 27.4505 22.0159 29.0533 23.1691 30.3741C24.3402 31.7153 25.7399 32.8627 26.6729 33.5577L26.8242 33.6616C27.5971 34.1452 28.5851 34.1104 29.3271 33.5577L29.6978 33.2765C30.6067 32.5728 31.8062 31.5476 32.8309 30.3741Z",
					fill: "#FF537F"
				})
			})]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_0_18",
		x: 13,
		y: 14,
		width: 30,
		height: 28,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 1 0 0 0 0 0.32549 0 0 0 0 0.498039 0 0 0 1 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_18"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_18",
				result: "shape"
			})
		]
	}), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_0_18",
		x1: 49.5,
		y1: 6.49999,
		x2: 6.5,
		y2: 49.5,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .1
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .277255,
				stopColor: "#DFCBF5",
				stopOpacity: .2
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#DFCBF5",
				stopOpacity: .25
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .723361,
				stopColor: "#DFCBF5",
				stopOpacity: .2
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: .1
			})
		]
	})] })]
});
export default SvgMeetWhere;
